import type {components, paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

export type Bank = components['schemas']['Bank'];

type FetchBanksOperation = paths['/executor_web/banks']['get'];

export type FetchBanksQuery = NonNullable<FetchBanksOperation['parameters']['query']>;
export type FetchBanksResponse = FetchBanksOperation['responses'][200]['content']['application/json'];

/** GET `/executor_web/banks` — см. `paths['/executor_web/banks']` в auth swagger */
export function fetchBanks(query?: FetchBanksQuery, signal?: AbortSignal) {
	return axiosInstance.get<FetchBanksResponse>('banks', {params: query, signal});
}
